import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export function Pill({
  children,
  icon,
  strong = false,
  className,
}: {
  children: ReactNode;
  icon?: ReactNode;
  strong?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border border-border-subtle px-2 py-0.5 text-xs whitespace-nowrap text-text-2',
        '[&_svg]:size-3.5 [&_svg]:shrink-0',
        strong && 'font-medium text-text-1',
        className,
      )}
    >
      {icon}
      {children}
    </span>
  );
}

export type Status = 'good' | 'warning' | 'critical';

const DOT: Record<Status, string> = {
  good: 'bg-status-good',
  warning: 'bg-status-warning',
  critical: 'bg-status-critical',
};

/** Status dot: always next to a text label, or labelled itself. */
export function StatusDot({ status, label }: { status: Status; label?: string }) {
  return label === undefined ? (
    <span aria-hidden className={cn('size-1.5 shrink-0 rounded-full', DOT[status])} />
  ) : (
    <span
      role="img"
      aria-label={label}
      className={cn('size-1.5 shrink-0 rounded-full', DOT[status])}
    />
  );
}
